<div
    *ngIf="user"
    class="navbar-user-menu"
    nz-dropdown
    [nzDropdownMenu]="menu"
    nzOverlayClassName="user-menu"
    nzTrigger="click"
>
    <app-user-card [user]="user"></app-user-card>
</div>

<nz-dropdown-menu #menu>
    <ul nz-menu>
        <li nz-menu-item>
            <a (click)="changePassword()" class="user-menu-item">
                <div class="user-menu-item__icon">
                    <app-icon nz-col name="icon-lock-2"></app-icon>
                </div>
                <div class="user-menu-item__label">
                    {{ 'LABELS.CHANGE_PASSWORD' | translate }}
                </div>
            </a>
        </li>
        <li nz-menu-item *ngIf="user?.role?.showUserLevelEmailConfiguration">
            <a (click)="emailNotifications()" class="user-menu-item">
                <div class="user-menu-item__icon">
                    <app-icon nz-col name="icon-address-2"></app-icon>
                </div>
                <div class="user-menu-item__label">
                    {{ 'USER.SETTINGS' | translate }}
                </div>
            </a>
        </li>
        <li nz-menu-item>
            <a (click)="logout()" class="user-menu-item">
                <div class="user-menu-item__icon">
                    <app-icon nz-col name="icon-log-out-1"></app-icon>
                </div>
                <div class="user-menu-item__label">
                    {{ 'LABELS.LOGOUT' | translate }}
                </div>
            </a>
        </li>
    </ul>
</nz-dropdown-menu>
